var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('img',{directives:[{name:"b-tooltip",rawName:"v-b-tooltip.hover",modifiers:{"hover":true}}],staticClass:"fast-track-icon",attrs:{"src":require("../assets/fast.svg"),"title":"This order should be prioritized"}})}
var staticRenderFns = []

export { render, staticRenderFns }